import { Component, OnInit, Input } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@Component({
  selector: 'bar-vert-stats',
  templateUrl: './bar-vert.component.html',
  styleUrls: ['./bar-vert.component.css']
})
export class BarVertComponent implements OnInit {

  @Input() data;
  multi: any[];

  view: any[] = [null, 400];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;

  colorScheme = {
    domain: ['#CB4728', '#6040B1', '#16B96A', '#F29D39', '#3E67C5', '#6FCF97', '#F2C94C']
  };

  constructor() {}

  ngOnInit() {
    this.data.answers.splice(0,0, {
      name: '',
      value: 0
    })
    this.data.answers.push({
      name: ' '.repeat(1),
      value: 0
    })
  }

}
